"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortLink = void 0;
const f2e_utils_config_1 = require("@kiki/f2e.utils.config");
const f2e_utils_url_obj_to_query_string_1 = require("@kiki/f2e.utils.url.obj-to-query-string");
const f2e_utils_request_1 = require("@kiki/f2e.utils.request");
class ShortLinkApi {
    getShortLink(params) {
        if (!params) {
            params = {
                origin: '',
            };
        }
        const URL = `${f2e_utils_config_1.config.api.get_short_link_url}?${(0, f2e_utils_url_obj_to_query_string_1.objToQueryString)(params)}`;
        return f2e_utils_request_1.request.post.call({}, URL, { rawBody: true, params });
    }
}
exports.ShortLink = new ShortLinkApi();
//# sourceMappingURL=short-link.js.map